<div class="canvas-parent-container">
  <div
    class="left-side-panel"
    [ngClass]="{
      'left-side-panel-opened':
        (canvasService.isSidePanelOpened &&
          !canvasService.isContentEditorOpened) ||
        (canvasService.isSidePanelOpened &&
          canvasService.isContentEditorOpened &&
          (canvasService.showSessionsPanel || canvasService.showCitationsPanel))
    }"
  >
    <ng-container *ngIf="canvasService.showSessionsPanel">
      <app-canvas-sessions />
    </ng-container>

    <ng-container *ngIf="canvasService.showCitationsPanel">
      <app-canvas-citations />
    </ng-container>
  </div>

  <div
    class="left-panel"
    [ngClass]="{
      'left-panel-small': canvasService.isContentEditorOpened
    }"
  >
    <app-canvas-chat
      [isLoadingChatConversations]="fetchSessionMessages"
      [nofo]="getCurrentContextNofo()"
      (onCanvasClose)="closeCanvas()"
      (onCanvasExpand)="expandCanvas()"
    />
  </div>

  <div
    class="right-panel"
    [ngClass]="{
      'right-panel-expanded':
        canvasService.isContentEditorOpened ||
        canvasService.isLoadingDocument ||
        canvasService.outlineDocument
    }"
  >
    <ng-container *ngIf="canvasService.isContentEditorOpened">
      <div class="w-100 h-100">
        <app-canvas-content-editor />
      </div>
    </ng-container>
  </div>
</div>
